import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=3bfac12a&scoped=true"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"
import style0 from "./NavMenu.vue?vue&type=style&index=0&id=3bfac12a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfac12a",
  null
  
)

export default component.exports